import { PAGES } from 'hb-react/shared/hooks/usePageMenuNames';
import { type EntityType } from 'hb-react/shared/utils/entitiesContentData/types';

export const ENTITY_TYPES = {
  adminEvent: 'admin_event',
  company: 'company',
  customPage: 'custom_page',
  forumDiscussion: 'forum_discussion',
  group: 'group',
  mediaCenterFile: 'media_center_file',
  mediaCenterFolder: 'media_center_folder',
  news: 'news',
  opportunity: 'opportunity',
  portfolioFile: 'portfolio_file',
  portfolioFolder: 'portfolio_folder',
  post: 'post',
  project: 'project',
  user: 'user',
  userEvent: 'user_event',
} as const;

export const LEGACY_ENTITY_TYPES = {
  adminEvent: 'network_event',
  opportunity: 'business_opportunity',
  post: 'feed_post',
} as const;

export const ENTITY_PAGE_MAP = {
  [ENTITY_TYPES.adminEvent]: PAGES.EVENTS,
  [ENTITY_TYPES.company]: PAGES.COMPANIES,
  [ENTITY_TYPES.customPage]: undefined,
  [ENTITY_TYPES.forumDiscussion]: PAGES.FORUM,
  [ENTITY_TYPES.group]: PAGES.TOPICS,
  [ENTITY_TYPES.mediaCenterFile]: PAGES.MEDIA_CENTER,
  [ENTITY_TYPES.mediaCenterFolder]: PAGES.MEDIA_CENTER,
  [ENTITY_TYPES.news]: PAGES.NEWS,
  [ENTITY_TYPES.opportunity]: PAGES.BUSINESS_OPPORTUNITIES,
  [ENTITY_TYPES.portfolioFile]: PAGES.PORTFOLIOS,
  [ENTITY_TYPES.portfolioFolder]: PAGES.PORTFOLIOS,
  [ENTITY_TYPES.post]: undefined,
  [ENTITY_TYPES.project]: PAGES.VENTURES,
  [ENTITY_TYPES.user]: undefined,
  [ENTITY_TYPES.userEvent]: PAGES.EVENTS,
  // Legacy types
  [LEGACY_ENTITY_TYPES.adminEvent]: PAGES.EVENTS,
  [LEGACY_ENTITY_TYPES.opportunity]: PAGES.BUSINESS_OPPORTUNITIES,
  [LEGACY_ENTITY_TYPES.post]: undefined,
};

type EntityTypesPerPage = Record<
  NonNullable<(typeof ENTITY_PAGE_MAP)[keyof typeof ENTITY_PAGE_MAP]>,
  Array<EntityType>
>;

// Transform the ENTITY_PAGE_MAP to a hash of page identifiers and entity types
// { 'events': ['admin_event', 'user_event'], ... }
export const ENTITY_TYPES_PER_PAGE = (
  Object.keys(ENTITY_PAGE_MAP) as Array<EntityType>
).reduce<EntityTypesPerPage>((acc, entityType) => {
  const pageIdentifier = ENTITY_PAGE_MAP[entityType];

  if (!pageIdentifier) {
    return acc;
  }

  if (!acc[pageIdentifier]) {
    acc[pageIdentifier] = [entityType];
  } else {
    acc[pageIdentifier].push(entityType);
  }

  return acc;
}, {} as EntityTypesPerPage);

// All pages that are associated with at least one entity type
export const ENTITY_PAGES = Object.keys(ENTITY_TYPES_PER_PAGE) as Array<
  keyof typeof ENTITY_TYPES_PER_PAGE
>;
